import {
  SetVideos,
  navigate,
  watchLiveData,
  getStatus,
  sendGetRequest,
  formatDate,
  sendDeleteRequest,
  sendPatchRequest,
  allowedOperations,
} from "../utils/utils";
import DataList from "./component/@list/list";
import { useState, useEffect } from "react";
import AppRoutes from "../routing/routes";
import { useSelector } from "react-redux";

const getTableHead = () => {
  return [
    { id: "createdAt", label: "Added on", alignRight: false },
    { id: "name", label: "Channel Name", alignRight: false },
    { id: "code", label: "Code", alignRight: false },
    { id: "expires", label: "Auth Expires On", alignRight: false },
    { id: "auth", label: "Auth Status", alignRight: false },
    { id: "_", alignRight: false },
  ];
};

const ChannelList = () => {
  const [dataList, setDataList] = useState([]);
  const [loading, onLoading] = useState(false);
  const { queue } = useSelector((state) => state.queue);
  const { canEdit, canDelete, canCreate } = allowedOperations();

  const onAuthClicked = (value, selected, force) => {
    sendPatchRequest(
      `channels/${selected.join()}/auth`,
      { force },
      (loading) => onLoading(loading),
      ({ data }) => {
        if (data) window.location.replace(data);
      }
    );
  };

  const onRefreshClicked = (value, selected) => {
    sendGetRequest(
      `channels/${selected.join()}/refresh`,
      (loading) => onLoading(loading),
      (data) => executeFetch(true)
    );
  };

  const actionOptions = [
    canDelete
      ? {
          icon: "delete",
          value: "delete",
          label: "Delete",
          onClick: (value, selected) => {
            onLoading(true);
            Promise.all(
              selected.map((uuid) => sendDeleteRequest("channels", uuid))
            ).then((response) => {
              executeFetch();
            });
          },
        }
      : null,
    canEdit
      ? {
          icon: "verified_user",
          value: "auth",
          label: "Authenticate",
          onClick: (value, selected) => onAuthClicked(value, selected, false),
        }
      : null,
    canEdit
      ? {
          icon: "lock_reset",
          value: "re-auth",
          label: "Re-Authenticate",
          onClick: (value, selected) => onAuthClicked(value, selected, true),
        }
      : null,
    canEdit
      ? {
          icon: "query_builder",
          value: "refresh",
          label: "Refresh",
          onClick: onRefreshClicked,
        }
      : null,
    canEdit
      ? {
          icon: "edit_note",
          value: "edit",
          label: "Edit",
          onClick: (_value, selected) =>
            navigate(
              `${AppRoutes.channels}/${AppRoutes.channel}?uuid=${selected.join(
                ""
              )}`,
              true
            ),
        }
      : null,
  ].filter(Boolean);
  const filterOptions = [];

  const executeFetch = (refresh = false) => {
    sendGetRequest(
      `channels`,
      (loading) => onLoading(refresh ? false : loading),
      (data) => {
        if (data) {
          setDataList(
            data.map((dat) => {
              return {
                ...dat,
                status:
                  dat.auth && dat.token && !dat.expired
                    ? "Authenticated"
                    : "Expired",
              };
            })
          );
        }
      }
    );
  };

  useEffect(() => {
    SetVideos([]);
    executeFetch();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (queue) watchLiveData(queue, "channels", (data) => executeFetch(true));
    // eslint-disable-next-line
  }, [queue]);

  return (
    <div>
      <DataList
        sectionTitle="Channels"
        createNewLabel={canCreate ? "Add Channel" : null}
        data={dataList}
        primaryKey="uuid"
        orderColumn="createdAt"
        emptyIcon="playlist_play"
        avatarKey="_"
        loading={loading}
        onCreateNewItem={() =>
          navigate(`${AppRoutes.channels}/${AppRoutes.channel}`, true)
        }
        headers={getTableHead()}
        rowData={(data) => {
          const _entries = [
            {
              value: formatDate(data.createdAt, "hh:mm A  MMM DD, YYYY"),
              width: 200,
            },
            { value: data.name, width: 200 },
            { value: data.code || "-", width: 200 },
            { value: data.expires, width: 200 },
            { ...getStatus(data.status), width: 80 },
          ];
          return {
            exclude: [
              `${data.status}`.toLowerCase() !== "expired" ? "auth" : "re-auth",
              `${data.status}`.toLowerCase() === "expired" ? "" : "auth",
            ],
            entries: _entries,
          };
        }}
        selectionOptions={actionOptions.filter((option) => option.value === "delete")}
        filterOptions={filterOptions}
        optionItems={actionOptions}
      />
    </div>
  );
};

export default ChannelList;
